/**
 * Superficie del bounded context Fiscal — solo dominio puro.
 * Tipos y funciones sin dependencias de infra/app/ui.
 * Importar desde aquí para evitar require cycles.
 */

export type {
  ArcaEnvironment,
  ArcaSetupValidateResult,
  BranchFiscalSettings,
  BranchFiscalSummary,
  FiscalContext,
  FiscalProfile,
  FiscalProfileInput,
  FiscalSetupStatus,
  IvaRateOption,
  PadronResult,
  PosFiscalBuyerDraft,
  TaxRegime,
} from './domain/fiscalTypes';

export { createEmptyFiscalBuyerDraft, isBranchPvReady, isValidIsoDateString } from './domain/fiscalTypes';

export {
  IVA_RATE_OPTIONS,
  MONOTRIBUTO_CATEGORY_ANNUAL_LIMIT_ARS,
  MONOTRIBUTO_CATEGORY_LETTERS,
  MONOTRIBUTO_LIMITS_REFERENCE_EFFECTIVE_FROM,
  MONOTRIBUTO_OFFICIAL_CATEGORIES_URL,
  formatMonotributoLimitsReferenceDate,
  formatMonotributoShortCap,
  formatCuitDisplay,
  isValidCuitDigits,
  monotributoCategoryPickerOptions,
  monotributoCategorySelectLabel,
  monotributoLimitForCategory,
  monotributoMonthlyLimitForCategory,
  normalizeCuitDigits,
  ARCA_PADRON_DELEGATION_HINT,
  isPadronUnauthorizedError,
  padronWarningFromError,
  spanishArcaConnectError,
  spanishArcaEnvironmentLabel,
  spanishIvaRateLabel,
  spanishTaxRegimeLabel,
  spanishTaxRegimeLabelCompact,
} from './domain/fiscalPresentation';

export {
  AFIP_CBTE,
  AFIP_IVA_RECEPTOR,
  reconcileCbteTipoAndReceptorIva,
  resolveInvoiceType,
  spanishInvoiceTypeLabel,
  spanishIvaReceptorLabel,
} from './domain/invoiceTypes';

export { FiscalPadronError } from './domain/fiscalErrors';

export type { LibroIvaBreakdown } from './domain/libroIvaTxt';
export type { LibroIvaCompraPercepciones } from './domain/libroIvaComprasTxt';

export { getDefaultPosFiscalMode, resolvePosSaleFiscalMode } from './domain/posFiscalDefaults';
export type { PosFiscalDefaultStrategy } from './domain/posFiscalDefaults';

export {
  FISCAL_TIP_LINE_LABEL,
  withFiscalTipLine,
} from './domain/fiscalTipLine';
export type { FiscalLineWithQtyPrice } from './domain/fiscalTipLine';

export {
  classifyFiscalEmissionError,
  formatFiscalEmissionErrorForUser,
  isFiscalDataRejectionError,
  isFiscalInvoiceAwaitingCae,
  resolveFiscalEmissionUi,
} from './domain/fiscalEmissionPresentation';
export type { FiscalEmissionErrorKind, FiscalEmissionUiTone } from './domain/fiscalEmissionPresentation';

export {
  FISCAL_SYSTEM_COPY,
  buildFiscalPendingInternalReceiptLines,
} from './domain/fiscalSystemCopy';
